// @flow

import { useCallback } from 'react';

import { type UserInputName } from '../user-input';
import { useUserInputValue } from './use-user-input-value';

type Value = string;
type RadioButtonEvent = SyntheticInputEvent<HTMLInputElement>;
type HandleChange = (event: RadioButtonEvent) => void;

export function useUserInputAsRadioButton(name: UserInputName): [Value, HandleChange] {
  const [value, setValue] = useUserInputValue(name);

  const handleChange = useCallback((event: RadioButtonEvent) => {
    setValue(event.target.value);
  }, [setValue]);

  return [value, handleChange];
}
